









































import { Vue, Component, Prop } from 'vue-property-decorator';
import StudentSelect from '@/components/student/studentSelect.vue';
import { GradesCollection, SendMessage } from '@/modules/recordControl';
import { Person } from '@/models/person';
import { GradesTypes, getGradesTypeName } from '@/enums/gradesTypes';
import { SchoolTypes, getSchoolTypeName } from '@/enums/schoolTypes';
import { SchoolTerms, getSchoolTermName } from '@/enums/schoolTerms';
import { UserTypes } from '@/enums/userTypes';
import store from '@/store';
import { ReturnTypes } from '@/enums/returnTypes';

interface Student {
  id: string;
  name: string;
}

Component.registerHooks([
  'beforeRouteEnter',
]);

@Component({
  components: {
    'student-select': StudentSelect,
  }
})
export default class RecordControlEdit extends Vue {
  private ReturnTypes = ReturnTypes;

  @Prop() private gradesCollectionId: string;
  @Prop() private semester: string;

  private customToolbar = [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
    [{ list: 'ordered'}, { list: 'bullet' }, { list: 'check' }],
    [{ indent: '-1'}, { indent: '+1' }],
    [{ color: [] }, { background: [] }],
    ['link']
  ];
  private previewVisible = false;
  private message: SendMessage | null = null;

  private gradesCollection: GradesCollection | null = null;

  private formRule = {
    title: [
      { required: true, message: 'タイトルを入力してください' },
    ],
    body: [
      { required: true, message: '内容を入力してください' },
      { validator: this.validateBody, trigger: 'blur' },
    ],
    studentList: [
      { required: true, validator: this.validateStudentList, trigger: 'blur' },
    ],
  };

  private validateBody(rule: any, value: string, callback: any) {
    if (value === '') {
      callback(new Error('内容を入力してください'));
    } else {
      callback();
    }
  }

  private validateStudentList(rule: any, value: string, callback: any) {
    const studentList = (this.$refs.tree as any).getCheckedStudents() as Person[];
    if (studentList.length === 0) {
      callback(new Error('配信先を選択してください'));
    } else {
      callback();
    }
  }

  get loading(): boolean {
    return this.$store.state.recordControl.loading;
  }

  get schoolId(): string {
    return this.$store.getters['auth/schoolId'];
  }

  get title(): string {
    if (!this.gradesCollection) {
      return '';
    } else {
      if (this.gradesCollection.gradesType === GradesTypes.OtherTest) {
        const testTypeName = this.gradesCollection.testTypeName;
        const testTimes = `${this.gradesCollection.fiscalYear}年度　第${this.gradesCollection.testTimes}回`;
        return `成績入力お願いメッセージ編集　－　${testTypeName}　${testTimes}`;
      } else {
        const gradesTypeName = getGradesTypeName(this.gradesCollection.gradesType);
        const schoolTypeName = getSchoolTypeName(this.gradesCollection.schoolType);
        const semester = getSchoolTermName(Number(this.semester));
        return `成績入力お願いメッセージ編集　－　${gradesTypeName}　${schoolTypeName}　${semester}`;
      }
    }
  }

  get previewBody(): string {
    if (!this.gradesCollection || !this.message) {
      return '';
    } else {
      return this.message.body;
    }
  }

  private beforeRouteEnter(to: any, from: any, next: any) {
    switch (store.getters['auth/userType']) {
      case UserTypes.Admin:
      case UserTypes.Owner:
      case UserTypes.AdminTutor:
        next();
        break;
      default:
        next({ name: 'Error' });
        break;
    }
  }

  private created() {
    this.loadData();
  }

  private deactivated() {
    this.$destroy();
  }

  private async loadData() {
    try {
      this.gradesCollection = await this.$store.dispatch('recordControl/getGradesCollection', this.gradesCollectionId);
      if (!this.gradesCollection) {
        this.$router.push({ name: 'RecordControlList' });
        return;
      }
      let gradesName: string;
      if (this.gradesCollection.gradesType === GradesTypes.OtherTest) {
        const testTypeName = this.gradesCollection.testTypeName;
        const testTimes = `${this.gradesCollection.fiscalYear}年度　第${this.gradesCollection.testTimes}回`;
        gradesName = `${testTypeName}　${testTimes}`;
      } else {
        const gradesTypeName = getGradesTypeName(this.gradesCollection.gradesType);
        const schoolTypeName = getSchoolTypeName(this.gradesCollection.schoolType);
        const semester = getSchoolTermName(Number(this.semester));
        gradesName = `${gradesTypeName}　${schoolTypeName}　${semester}`;
      }
      this.message = {
        gradesCollectionId: this.gradesCollectionId,
        schoolTerm: Number(this.semester),
        title: '成績入力のお願い',
        body: `<p><strong><u>${gradesName}</u></strong> の成績を入力してください。<p>`,
        returnType: ReturnTypes.Disable,
        studentList: [],
      };
    } catch (error) {
      this.$router.push({ name: 'RecordControlList' });
      return;
    }
  }

  private async submitForm() {
    (this.$refs.form as any).validate((valid: any) => {
      if (valid) {
        this.submit();
      } else {
        return false;
      }
    });
  }

  private async submit() {
    const gradesCollection = this.gradesCollection as GradesCollection;
    const studentList = (this.$refs.tree as any).getCheckedStudents() as Person[];

    const message = this.message as SendMessage;
    const gradesCollectionId = message.gradesCollectionId;

    message.studentList = studentList;

    try {
      await this.$store.dispatch('recordControl/sendMessageGradesCollection', message);
      this.$notify({
        title: '配信完了',
        message: '成績入力お願いメッセージを配信しました。',
        position: 'bottom-right',
        dangerouslyUseHTMLString: true
      });
      this.$router.push({ name: 'RecordControlList' });
    } catch (error) {
      this.$notify({
        title: 'エラー',
        message: '成績入力お願いメッセージの配信に失敗しました。',
        position: 'bottom-right',
        dangerouslyUseHTMLString: true
      });
    }
  }

  private cancel() {
    this.$router.push({ name: 'RecordControlList' });
  }
}
